import { AbbreviateCurrency } from 'abbreviate-currency';

export const formatDate = (date: string | Date) =>
  new Date(date).toLocaleDateString();

export const formatCurrency = (value: number) => {
  const isNegative = value < 0;
  const regex = '\\d(?=(\\d{3})+\\D)';
  const number = Math.abs(value).toFixed(2);

  return `${isNegative ? '- ' : ''} R$ ${number
    .replace('.', ',')
    .replace(new RegExp(regex, 'g'), '$&.')}`;
};

export const abbreviateCurrency = new AbbreviateCurrency({
  language: 'pt-BR',
  currency: 'BRL',
  useLowerCaseSymbols: true,
  digitGroups: [
    { symbol: ' million', digits: 7 },
    { symbol: ' billion', digits: 10 },
    { symbol: ' trillion', digits: 13 },
  ],
});
